import { View } from 'backbone.marionette';
import { Collection } from 'backbone';
import MatchCentreMatches  from '../MatchCentreMatches';
import template from './index.jst'

export class MatchCentreDay extends View {
	get tagName() {
		return 'li';
	}

	regions() {
		return {
			line: {
				el: 'ul',
				replaceElement: true
			}
		}
	}

	get template() {
		return template;
	}

	onRender() {
		const matches = this.model.get('matches');


		//show child nodes if they are present
		if (matches.length) {
			const matchCentreMatches = new MatchCentreMatches({
				collection: new Collection(matches)
			});
			this.showChildView('line', matchCentreMatches);
		}
	}

}

export default MatchCentreDay;